import {combineReducers} from 'redux';
import {visitorFormRed } from './visitorRed';
import {checkVisitorRed} from './checkVisitor'
const reducer = combineReducers({
   visitorFormRed,checkVisitorRed
    });
    
    export default reducer;
